import { render, staticRenderFns } from "./BusinessRules.vue?vue&type=template&id=da006f30&scoped=true&"
import script from "./BusinessRules.vue?vue&type=script&lang=js&"
export * from "./BusinessRules.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRules.vue?vue&type=style&index=0&id=da006f30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da006f30",
  null
  
)

export default component.exports